import { MessageCircle } from "lucide-react";
import { siteContent } from "../../data/content";

export const WhatsAppButton = () => {
  const whatsappUrl = `${siteContent.contact.whatsappLink}?text=${encodeURIComponent(siteContent.contact.whatsappMessage)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] text-white px-4 py-3 shadow-lg hover:bg-[#1da851] transition-all hover:scale-105 group"
      data-testid="sticky-whatsapp-btn"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="hidden sm:inline font-medium">WhatsApp Us</span>
    </a>
  );
};
